// extracted by mini-css-extract-plugin
export var dropdown = "_l2-1";
export var hidden = "_l2-0";